const DIFFICULTIES = [
  {
    icon: "ri-question-line",
    title: "信息众说纷纭",
    desc: "同一件事往往有多个版本。有人只转述二手消息，有人带着立场带节奏，字面上看着都像真的，实则真假混杂。",
  },
  {
    icon: "ri-scissors-cut-line",
    title: "截图断章取义",
    desc: "聊天记录、录音、图片最容易在传播中被裁剪。脱离上下文的一句话，前因后果完全可能是另一回事。",
  },
  {
    icon: "ri-refresh-line",
    title: "情节反复反转",
    desc: "随着当事人回应、新证据出现，事件走向常被打乱。没有更新的时间线，很容易停在错误版本上。",
  },
  {
    icon: "ri-filter-2-line",
    title: "缺少可信锚点",
    desc: "公开的权威信源可能有限，许多细节只能靠多方交叉印证。锚点不足，结论就站不稳。",
  },
];

export default function IntroSection() {
  return (
    <section id="intro" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl">
          <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600 uppercase">
            <i className="ri-focus-3-line w-4 h-4 flex items-center justify-center" />
            01 · 事件导读
          </p>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            这起事件，为什么越看越乱？
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-loose">
            “看料门”被热议以来，网上的说法快速铺开，却又彼此冲突。这并非个例——凡是信息快速流动、
            缺少权威通报的争议事件，都容易出现“一个故事多个版本”的局面。要真正看懂，与其追问谁说的
            更像，不如先厘清<b className="font-semibold text-foreground-950">信息来源、时间先后与证据强度</b>。
          </p>
          <p className="mt-3 text-foreground-700 text-sm md:text-base leading-loose">
            本站不是简单地复述某一方的说法，而是把<b className="font-semibold text-foreground-950">梳理争议的通用框架</b>
            讲清楚：一场事件通常如何起因、如何发酵、如何被回应、又如何沉淀为记忆。把握住这条脉络，
            任何碎片化消息你都能放回正确的位置。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {DIFFICULTIES.map((d, i) => (
            <article
              key={d.title}
              className="bg-background-100 border border-background-200 rounded-lg p-5 flex flex-col"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 mb-4">
                <i className={`${d.icon} text-xl w-5 h-5 flex items-center justify-center`} />
              </span>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                {d.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{d.desc}</p>
              <span className="mt-4 text-xs text-secondary-600 font-label">
                {String(i + 1).padStart(2, "0")}
              </span>
            </article>
          ))}
        </div>

        <figure className="mt-12 max-w-3xl border-l-4 border-accent-500 pl-5 py-1">
          <blockquote className="font-heading text-lg md:text-xl text-foreground-900 leading-relaxed">
            “看一件事，先看它的<b className="text-primary-600">出处</b>与<b className="text-primary-600">时间</b>，
            再看它<b className="text-primary-600">讲给谁听</b>。弄清这三点，大多数混乱都能自行瓦解。”
          </blockquote>
        </figure>
      </div>
    </section>
  );
}